import { API_BASE_URL } from '../config/api'

/** Railway/API image by filename (preserves ?v= cache-bust query if present) */
export function getApiImageUrl(filename: string): string {
  const withoutPrefix = filename.replace(/^\/images\//, '')
  const [pathPart, query] = withoutPrefix.split('?')
  const file = pathPart.split('/').pop() || pathPart
  const base = `${API_BASE_URL}/api/images/filename/${encodeURIComponent(file)}`
  return query ? `${base}?${query}` : base
}

/** Same-origin static image (Vite public/images after build sync) */
export function getStaticImageUrl(filename: string): string {
  const file = filename.replace(/^\/images\//, '').split('/').pop() || filename
  return `/images/${file}`
}

/** Prefer API; callers can fall back to static on error */
export function resolveImageUrl(pathOrFilename: string): string {
  if (!pathOrFilename) return ''
  if (pathOrFilename.startsWith('http://') || pathOrFilename.startsWith('https://')) {
    return pathOrFilename
  }
  if (pathOrFilename.startsWith('/images/')) {
    return getApiImageUrl(pathOrFilename)
  }
  return getApiImageUrl(pathOrFilename)
}

export function imageFallbackChain(pathOrFilename: string): string[] {
  const file = pathOrFilename.replace(/^\/images\//, '').split('/').pop() || pathOrFilename
  return [getApiImageUrl(file), getStaticImageUrl(file)]
}
